import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import useQuestionnaireStore from '../store/useQuestionnaireStore';
import { ChevronLeft, Check } from 'lucide-react';
import Button from '../components/common/Button';

const conditionsList = [
    "High blood pressure (Hypertension)",
    "Heart disease / Angina",
    "Heart attack (Myocardial infarction)",
    "Palpitations / Irregular heartbeat",
    "Swelling in feet or breathlessness on exertion",
    "Cardiac surgery / Pacemaker",
    "COPD",
    "Asthma",
    "TB",
    "COVID-19",
    "Diabetes",
    "Obesity",
    "Osteoporosis",
    "Thyroid disorder",
    "Rheumatoid arthritis",
    "Ankylosis spondylysis",
    "SLE",
    "Fibromyalgia",
    "Gout",
    "Cancer",
    "None"
];

const Step10_History = () => {
    const navigate = useNavigate();
    const { medicalConditions, setMedicalConditions } = useQuestionnaireStore();

    const toggleCondition = (condition) => {
        if (condition === "None") {
            // If None is toggled, either select ONLY None or unselect it
            if (medicalConditions.includes("None")) {
                setMedicalConditions([]);
            } else {
                setMedicalConditions(["None"]);
            }
            return;
        }

        // If another condition is picked, remove "None" automatically
        const withoutNone = medicalConditions.filter(c => c !== "None");
        if (withoutNone.includes(condition)) {
            setMedicalConditions(withoutNone.filter(c => c !== condition));
        } else {
            setMedicalConditions([...withoutNone, condition]);
        }
    };

    const handleNext = () => {
        console.log("Selected Conditions:", medicalConditions);
        navigate('/step-11'); 
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { 
            opacity: 1, 
            transition: { staggerChildren: 0.05 } 
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 10 },
        visible: { opacity: 1, y: 0 }
    };

    return (
        <motion.div
            className="page step10-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="step-header">
                <button onClick={() => navigate(-1)} className="back-button">
                    <ChevronLeft size={20} /> Back
                </button>
                <h2>Medical History</h2>
                <p>Do you have or have you ever been diagnosed with any of the following?</p>
            </div>

            <motion.div 
                className="conditions-grid"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {conditionsList.map((condition) => {
                    const isSelected = medicalConditions.includes(condition);
                    return (
                        <motion.button
                            key={condition}
                            className={`condition-chip ${isSelected ? 'selected' : ''}`}
                            onClick={() => toggleCondition(condition)}
                            variants={itemVariants}
                            whileTap={{ scale: 0.98 }}
                        >
                            <div className="checkbox-circle">
                                {isSelected && <Check size={14} strokeWidth={3} />}
                            </div>
                            <span className="label">{condition}</span>
                        </motion.button>
                    );
                })}
            </motion.div>

            <div className="navigation-buttons">
                <Button onClick={handleNext}>Next</Button>
            </div>
        </motion.div>
    );
};

export default Step10_History;